// @Flow
import Vue from 'vue'
import type { B2bClientInterface } from '../../../services/b2b/b2b-client-interface'
import * as mutationTypes from './mutation-types'
import type { RorProductsPage } from '../../../types/ror-products-page'

export default {
  loadProducts: async ({ commit, state }: { commit: (string, RorProductsPage) => void }, cardId): Promise<void> => {
    const client: B2bClientInterface = Vue.prototype.$container.b2bClient
    commit(mutationTypes.SET_PRODUCTS_PAGE, await client.getCardRorProducts(
      cardId,
      state.pageNumber,
      state.pageSize,
      state.orderBy,
      state.orderDirection
    ))
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/ror-product/actions.js